<template>
  <header>
    <div class="sub_header">
      <div class="logo_login">
        <v-btn class="btn_not_hover" text to="/">
          <img class="logo" alt src="../assets/img/logo_x2.png" />
          <img class="logo _mobile" alt src="../assets/img/logo_x2.png" />
        </v-btn>
      </div>
      <div v-if="isLogin" class="acount">
        <v-menu class="" content-class="custom" bottom left>
          <template v-slot:activator="{ on, attrs }">
            <v-btn dark icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item>
              <v-btn :ripple="false" @click="signOut()" class="" text>
                <span>CERRAR SESIÓN</span>
                <v-icon>mdi-logout-variant</v-icon>
              </v-btn>
            </v-list-item>
          </v-list>
        </v-menu>
        <div class="m-profile">
          <span class="m-icon">
            <v-icon>mdi-account</v-icon>
          </span>
          <div class="m-ctn-profile">
            <span v-if="getUser != null" class="m-username">{{
              getUser.name
            }}</span>
          </div>
        </div>
      </div>
      <div v-else class="acount">
        <v-btn class="btn-signup" to="/signup">Registrar</v-btn>
      </div>
    </div>
  </header>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "Header",
  components: {},
  data() {
    return {
      user: null
    };
  },
  async mounted() {
    if (this.isLogin) {
      this.user = await this.queryUser();
    }
  },
  async created() {},
  methods: {
    ...mapActions(["signOut", "queryUser"])
  },
  computed: {
    ...mapGetters(["isLogin", "getUser"])
  }
};
</script>
<style lang="scss">
@import "../assets/scss/base";
</style>
